import React from 'react';
import './MobileNotSupported.scss';
import { IconDeviceDesktop, IconMail } from '@tabler/icons-react';

function MobileNotSupported() {
  return (
    <div className="mobile-not-supported">
      <div className="mobile-not-supported-content">
        <div className="icon-container">
          <IconDeviceDesktop size={80} stroke={1.5} />
        </div>
        
        <h1>Desktop Required</h1>
        
        <p className="main-message">
          PrescriptSure is optimized for desktop and tablet devices to provide 
          the best experience for healthcare professionals.
        </p>
        
        <div className="instructions">
          <h2>To access PrescriptSure:</h2>
          <ul>
            <li>Open this site on your desktop computer or laptop</li>
            <li>Use a tablet device (iPad, Android tablet, etc.)</li>
            <li>Ensure your screen width is at least 768 pixels</li>
          </ul>
        </div>
        
        <div className="support-section">
          <p className="support-text">
            Need help? Contact our support team
          </p>
          <a href="mailto:support@prescriptsure.com" className="support-link">
            <IconMail size={20} />
            support@prescriptsure.com
          </a>
        </div>
        
        <div className="footer">
          <p>&copy; {new Date().getFullYear()} PrescriptSure. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}

export default MobileNotSupported;
